export default __webpack_public_path__ + "static/media/icon-circle-notes.a50a7c54.svg";